<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Line Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="line" :options="ChartOptions.linechart.options" :series="ChartOptions.linechart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Area Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="area" :options="ChartOptions.areachart.options" :series="ChartOptions.areachart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Column Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="bar" :options="ChartOptions.columnchart.options" :series="ChartOptions.columnchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Bar Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="bar" :options="ChartOptions.barchart.options" :series="ChartOptions.barchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Mixed Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="line" :options="ChartOptions.mixedchart.options" :series="ChartOptions.mixedchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Candlestick Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="candlestick" :options="ChartOptions.candlestickchart.options" :series="ChartOptions.candlestickchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Pie Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="pie" :options="ChartOptions.piechart.options" :series="ChartOptions.piechart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Donut Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="donut" :options="ChartOptions.donutchart.options" :series="ChartOptions.donutchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Redar Chart</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="radar" :options="ChartOptions.redarchart.options" :series="ChartOptions.redarchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Radial Bar Charts</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="radialBar" :options="ChartOptions.radialbarchart.options" :series="ChartOptions.radialbarchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Bubble Charts</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="bubble" :options="ChartOptions.bubblechart.options" :series="ChartOptions.bubblechart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Scatter Charts</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="scatter" :options="ChartOptions.scatterchart.options" :series="ChartOptions.scatterchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Heatmap Charts</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <VueApexCharts  type="heatmap" :options="ChartOptions.heatmapchart.options" :series="ChartOptions.heatmapchart.series"></VueApexCharts>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import ApexChart from "@/demo-data/Chart/Apex.js";

export default {
  components: {
    VueApexCharts
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
   ChartOptions: ApexChart[0],
    };
  },
};
</script>